import { formatAccessDenied, isAccessDenied } from '@/lib/utils/access-denied';
import {
  formatRequestFailure,
  isRequestFailureMessageKind,
} from '@/lib/utils/request-failure';

/**
 * Returns toast error messages
 */
export function generateApiErrorToastContent(error: any) {
  if (isAccessDenied(error)) {
    return formatAccessDenied(error.data);
  }

  if (isRequestFailureMessageKind(error?.failure?.kind)) {
    return formatRequestFailure(error.failure.kind, error.reference);
  }

  if (error?.description || Object.keys(error?.errors || {}).length > 0) {
    const errorMessages = Object.values(error?.errors || {}).flat() as string[];

    return (
      <div className='space-y-2'>
        {error?.title && <p>{error.title}</p>}
        {error?.description && <p>{error.description}</p>}

        {errorMessages.length > 0 && (
          <ul className='list-disc list-inside text-sm space-y-1'>
            {errorMessages.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        )}
      </div>
    );
  }

  return error?.title || error?.detail
    ? `${error?.detail ? error.detail : error.title}`
    : 'An error has occurred. Please try again.';
}
